import { render, staticRenderFns } from "./BaseLinkedTender.vue?vue&type=template&id=fec46724"
import script from "./BaseLinkedTender.vue?vue&type=script&lang=js"
export * from "./BaseLinkedTender.vue?vue&type=script&lang=js"
import style0 from "./BaseLinkedTender.vue?vue&type=style&index=0&id=fec46724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports